import type { User } from 'types/user';
import { JourneyProfileType, ManagerJourneyStage, resolveJourneyProfile } from 'utils/journeyProfile';

const FUNCIONARIO_CHALLENGE_ORDER = [
  'FiwbxsD',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'Fiwc6QJ'
];

const PARTICIPANTE_CHALLENGE_ORDER = [
  'FodzghB',
  'FiwbM5P',
  'Fiwb2MF',
  'Fiwcnvh',
  'FiwcAya',
  'FodzBKN',
  'FodzTpb',
  'FodAq4u'
];

const GESTOR_CHALLENGE_ORDER: Partial<Record<ManagerJourneyStage, string[]>> = {
  etapa1: [
    'FohRQJm',
    'FiwbM5P',
    'Fiwb2MF',
    'Fiwcnvh',
    'FohR25H',
    'FohSwEF',
    'FohSSjL'
  ]
};

const getManagerChallengeOrder = (stage: ManagerJourneyStage): string[] => {
  return GESTOR_CHALLENGE_ORDER[stage] || GESTOR_CHALLENGE_ORDER.etapa1 || [];
};

const getJourneyChallengeIds = (
  profile: JourneyProfileType,
  managerStage: ManagerJourneyStage = 'etapa1'
): string[] => {
  if (profile === 'gestor') {
    return getManagerChallengeOrder(managerStage);
  }

  if (profile === 'participante') {
    return PARTICIPANTE_CHALLENGE_ORDER;
  }

  return FUNCIONARIO_CHALLENGE_ORDER;
};

const filterChallengesByJourneyProfile = <T extends { id: string }>(
  challenges: T[],
  user: User | null | undefined,
  managerStage: ManagerJourneyStage = 'etapa1'
): T[] => {
  const profile = resolveJourneyProfile(user);
  const challengeOrder = getJourneyChallengeIds(profile, managerStage);

  if (!challengeOrder.length) return challenges;

  const orderMap = new Map(challengeOrder.map((challengeId, index) => [challengeId, index]));

  return challenges
    .filter((challenge) => orderMap.has(challenge.id))
    .sort((challengeA, challengeB) => {
      return (orderMap.get(challengeA.id) ?? 0) - (orderMap.get(challengeB.id) ?? 0);
    });
};

export { filterChallengesByJourneyProfile };
